import { TypedDefinition } from '@rehaje/core'

import type { TypedSchema } from '@rehaje/core'

export class ActionCallElementDefinition extends TypedDefinition {
  override extends = ['Action']
  override properties: TypedSchema[] = [
    {
      name: 'props',
      properties: [
        {
          name: 'elementId',
          type: 'Schema.Union',
          types: [
            {
              expect: {
                type: 'Schema.String'
              },
              type: 'Schema.Mustache'
            },
            {
              type: 'Schema.String'
            }
          ]
        },
        {
          name: 'methodName',
          type: 'Schema.Union',
          types: [
            {
              expect: {
                type: 'Schema.String'
              },
              type: 'Schema.Mustache'
            },
            {
              type: 'Schema.String'
            }
          ]
        },
        {
          items: [
            {
              expect: {
                type: 'Schema.Any'
              },
              type: 'Schema.Mustache'
            },
            {
              type: 'Schema.Any'
            }
          ],
          name: 'parameters',
          type: 'Schema.Array'
        }
      ],
      type: 'Schema.Object'
    }
  ]

  override relationTo = 'Schema.Action'
}
